import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { SearchInput } from '../../../../../generic/ui/SearchInput';
import { DateRangePicker } from '../../../../../generic/ui/DatePicker';
import StampIcon from '../../../../../generic/icons/IconLib/StampIcon';
import SelectFromTheList from '../../../../../generic/customSearchComponents/SelectFromTheList';
import { ITableOfTableItem } from '../../../../../modules/API/Defaults/models/tableOfTables';

interface Props {
    input: string;
    setInput: (value: string) => void;
    placeholder?: string;
    setDate: Dispatch<SetStateAction<string>>;
    setEndDate: Dispatch<SetStateAction<string>>;
    handleDate: (e: object | object[]) => void;
    selectedDate: Date | Date[] | false;
    setDefaultDate: string | string[] | null;
    isMashgiah: boolean;
    filterKoserList: ITableOfTableItem[] | undefined;
    selectedKosherID: number | undefined;
    handleFilterKosher: (id: string) => void;
    showStampButton: boolean;
    onStampClick: () => void;
}

const KosherTeudotSelectBar: React.FC<Props> = ({
    input,
    setInput,
    placeholder,
    setDate,
    setEndDate,
    handleDate,
    selectedDate,
    setDefaultDate,
    isMashgiah,
    filterKoserList,
    selectedKosherID,
    handleFilterKosher,
    showStampButton,
    onStampClick,
}) => {
    return (
        <SelectBarShell>
            <SearchInput
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder={placeholder ?? 'חיפוש'}
            />
            {showStampButton && (
                <StampBtn type='button' onClick={onStampClick} aria-label='stamp filter'>
                    <StampIcon />
                </StampBtn>
            )}
            {isMashgiah && (
                <KosherSelectShell>
                    <SelectFromTheList
                        lable={'הכול'}
                        list={filterKoserList}
                        dispalyFieldName={'Description'}
                        itemKey={'SecondCode'}
                        fieldValue={'SecondCode'}
                        selectFunction={handleFilterKosher}
                        selectedValue={selectedKosherID}
                    />
                </KosherSelectShell>
            )}
            <DateRangePicker
                selected={setDefaultDate ? selectedDate : false}
                setDate={setDate}
                setDateEnd={setEndDate}
                onChange={(dates) => handleDate(dates as unknown as object | object[])}
            />
        </SelectBarShell>
    );
};

export default KosherTeudotSelectBar;

const SelectBarShell = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`;

const StampBtn = styled.button`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.875rem;
    height: 2.875rem;
    border-radius: 0.875rem;
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.ink};
    border: 1px solid ${({ theme }) => theme.colors.accent};
    cursor: pointer;
    transition: all ${({ theme }) => theme.motion.fast} ease;

    svg {
        width: 1.1rem;
        height: 1.1rem;
        font-size: 1.1rem;
    }

    &:hover {
        background: ${({ theme }) => theme.colors.accentDeep};
        border-color: ${({ theme }) => theme.colors.accentDeep};
    }

    &:active {
        transform: translateY(1px);
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 2.5rem;
        height: 2.5rem;
    }
`;

const KosherSelectShell = styled.div`
    flex-shrink: 0;
    box-sizing: border-box;
    min-width: 9rem;
    height: 2.875rem;
    background: ${({ theme }) => theme.colors.surface};
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    border-radius: 0.875rem;
    direction: rtl;
    display: flex;
    align-items: center;
    padding: 0 0.5rem;
    transition:
        border-color ${({ theme }) => theme.motion.fast} ease,
        box-shadow ${({ theme }) => theme.motion.fast} ease;

    &:hover {
        border-color: ${({ theme }) => theme.colors.inputBorderHover};
    }

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.ink};
        box-shadow: ${({ theme }) => theme.shadows.focus};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 2.5rem;
        min-width: 7rem;
    }
`;
